import { connect } from "react-redux";
import { getDropDownUser } from "../../store/actions";
import { Col, InputGroup, Label, Row } from "reactstrap";
import { useEffect, useState, useMemo, useRef } from "react";
import "./filterAdminStyle.scss";
import Select, { components } from "react-select";
import moment from "moment";
import InputDateRange from "../Inputs/InputDateRange";
import InputSearch from "../Inputs/InputSearch";

const FilterAdmin = ({
  dropdownUser,
  getDropDownUserRequest,
  setObjFilter,
  placeholderSearch,
  isFistRender,
}) => {
  const [createDateFilter, setCreateDateFilter] = useState("");
  const [updateDateFilter, setUpdateDateFilter] = useState("");
  const [searchFilter, setSearchFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState(optionsStatus[1]);
  const [createdByUserFilter, setCreatedByUserFilter] = useState(null);
  const [updatedByUserFilter, setUpdatedByUserFilter] = useState(null);
  const inputCreateDateRef = useRef(null);
  const inputUpdateDateRef = useRef(null);

  const userMemoDropdown = useMemo(() => {
    var resultado = dropdownUser.map((item) => {
      return {
        value: item.email,
        label: item.login,
      };
    });

    return resultado;
  }, [dropdownUser]);

  useEffect(() => {
    getDropDownUserRequest();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const debounce = setTimeout(() => {
      const objFilter = {
        createDateStart:
          createDateFilter !== ""
            ? moment(createDateFilter[0]).format("YYYY-MM-DD").toString()
            : "",
        updateDateStart:
          updateDateFilter !== ""
            ? moment(updateDateFilter[0]).format("YYYY-MM-DD").toString()
            : "",
        createDateEnd:
          createDateFilter !== ""
            ? moment(createDateFilter[1]).format("YYYY-MM-DD").toString()
            : "",
        updateDateEnd:
          updateDateFilter !== ""
            ? moment(updateDateFilter[1]).format("YYYY-MM-DD").toString()
            : "",
        createUser:
          createdByUserFilter !== null ? createdByUserFilter.value : null,
        updateUser:
          updatedByUserFilter !== null ? updatedByUserFilter.value : null,
        status:
          statusFilter !== null
            ? statusFilter.value === 2
              ? true
              : statusFilter.value === 3
              ? false
              : null
            : null,
        search: searchFilter,
      };

      if (!isFistRender) setObjFilter(objFilter);
    }, 500);

    return () => clearTimeout(debounce);
    // eslint-disable-next-line
  }, [
    searchFilter,
    createDateFilter,
    updateDateFilter,
    statusFilter,
    createdByUserFilter,
    updatedByUserFilter,
  ]);

  const handleClearFilter = () => {
    setSearchFilter("");
    setCreateDateFilter("");
    setUpdateDateFilter("");
    setCreatedByUserFilter(null);
    setUpdatedByUserFilter(null);
    setStatusFilter(null);

    //Remove estilos date range
    inputCreateDateRef.current.altInput.classList.remove("input-date-selected");
    inputCreateDateRef.current.altInput.style.backgroundColor = "#FFF";
    inputUpdateDateRef.current.altInput.classList.remove("input-date-selected");
    inputUpdateDateRef.current.altInput.style.backgroundColor = "#FFF";
  };

  const CustomClear = ({ children, ...props }) => (
    <components.ClearIndicator {...props}>
      <i
        className="fas fa-times"
        style={{ fontSize: "14px", color: "#888" }}
      ></i>
    </components.ClearIndicator>
  );

  const customStyles = {
  singleValue: (base, state) => ({
    ...base,
    color: state.isSelected ?  "#9599AD" : "#0576B9",
  }),
  placeholder: (base) => ({
    ...base,
    color: "#9599AD",
    fontWeight: "400"
  }),
  control: (base, state) => ({
    ...base,
    backgroundColor: state.hasValue ? "#EFF2F7" : "#FFF",
  }),
};

  return (
    <>
      <Row>
        <Col>
          <Label className="label-filter">Search</Label>
          <InputGroup>
            <InputSearch
              placeholderSearch={placeholderSearch}
              searchValueFilter={searchFilter}
              setSearchValueFilter={setSearchFilter}
            />
          </InputGroup>
        </Col>
        <Col>
          <Label className="label-filter">Creation Date</Label>
          <InputGroup>
            <InputDateRange
              dateValueFilter={createDateFilter}
              setDateValueFilter={setCreateDateFilter}
              flatpickrRef={inputCreateDateRef}
            />
          </InputGroup>
        </Col>
        <Col>
          <Label className="label-filter">Update Date</Label>
          <InputGroup>
            <InputDateRange
              dateValueFilter={updateDateFilter}
              setDateValueFilter={setUpdateDateFilter}
              flatpickrRef={inputUpdateDateRef}
            />
          </InputGroup>
        </Col>
      </Row>
      <Row className="my-2">
        <Col>
          <Label className="label-filter">Active Status</Label>
          <Select
            className="filter-select"
            options={optionsStatus}
            onChange={(e) => setStatusFilter(e)}
            value={statusFilter}
            placeholder="Select Status"
            isClearable={false}
            styles={customStyles}
          />
        </Col>
        <Col>
          <Label className="label-filter">Created By</Label>
          <Select
            components={{ClearIndicator: CustomClear}}
            className="filter-select"
            options={userMemoDropdown}
            onChange={(e) => setCreatedByUserFilter(e)}
            value={createdByUserFilter}
            placeholder="Select User"
            isClearable
            styles={customStyles}
          />
        </Col>
        <Col>
          <Label className="label-filter">Updated By</Label>
          <Select
            components={{ClearIndicator: CustomClear}}
            className="filter-select"
            options={userMemoDropdown}
            onChange={(e) => setUpdatedByUserFilter(e)}
            value={updatedByUserFilter}
            placeholder="Select User"
            isClearable
            styles={customStyles}
          />
        </Col>
      </Row>
      <Row className="d-flex justify-content-end my-2">
        <p className="clear-link" onClick={handleClearFilter}>
          Clear All
        </p>
      </Row>
    </>
  );
};

const mapStateToProps = ({
  UserReducer: { loadingUser, listaUser, dropdownUser },
}) => ({
  loadingUser,
  listaUser,
  dropdownUser,
});

const mapDispatchToProps = {
  getDropDownUserRequest: getDropDownUser.request,
};

const optionsStatus = [
  { value: 1, label: "All" },
  { value: 2, label: "Active" },
  { value: 3, label: "Inactive" },
];

export default connect(mapStateToProps, mapDispatchToProps)(FilterAdmin);
